import { BehaviorSubject } from "rxjs";
import { LoadState } from "./load-state/load-state";
import { LoadStatusEnum } from "./load-state/load-state.enum";

export class BaseModel<T> {

  private _data= new BehaviorSubject<T>(null);
  private _loadState = new BehaviorSubject<LoadState<T>>(new LoadState({status: LoadStatusEnum.NotLoaded, data: {} as T}));

  loadState$ = this._loadState.asObservable();
  data$ = this._data.asObservable();
  id?: number;
  uid?: string;


  constructor(init?: Partial<BaseModel<T>>) {

    if (init) {
      this.id =  init.id;
      this.uid =  init.uid;
      if (init.loadState) {
        this.loadState = new LoadState(init.loadState);
      }
    }
    if (!this.data) {
      this.setData({} as T);
    }

    if (!this.loadState) {
      this.loadState = new LoadState({status:LoadStatusEnum.NotLoaded, data: {} as T});
    }
    this.intiSubscription();
  }


  protected intiSubscription() {
    this._loadState.subscribe(ls=> {
      if (ls.data) {
        if (ls.status === LoadStatusEnum.Loaded) {
          // Try both uppercase and lowercase id properties
          this.id = (ls.data as any).Id || (ls.data as any).id;
          this.uid = (ls.data as any).UniqueId || (ls.data as any).uid;
        }
        this.setData(ls.data);
      }
    })
  }



  get loadState(): LoadState<T> {
    return this.getLoadState();
  }

  set loadState(v: LoadState<T>) {
    this.setLoadState(v);
  }

  protected setLoadState(v: LoadState<T>) {
    this._loadState.next(v);
  }

  protected getLoadState(): LoadState<T> {
    return this._loadState.value;
  }

  protected setData(v: T) {
    // Only set id if it's not already set, and try both uppercase and lowercase
    this.id = this.id ?? ((v as any).Id || (v as any).id);
    this.uid = this.uid ?? ((v as any).UniqueId || (v as any).uid);
    this._data.next(v);
  }

  get data(): T {
    return this._data.value;
  }


}
